export default {};
throw new Error(`Could not resolve "date-fns-tz" imported by "react-datepicker". Is it installed?`)